module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ff604ee848c4601eed6cdba13c6b461f.png";